import React, { useEffect, useRef } from 'react';

import KeForms from '@app/interfaces/KeForms';

const FormRichText: React.FC<KeForms.RichText> = ({ id, name, value, required, onChange }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const editorRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleChange = (event: Event) => {
      // I'm not sure if we should pass the <trix-editor> or the <input>, but their value is the same at this point.
      const target = inputRef.current;
      // Fake a React ChangeEvent to keep the interface the same as other form components.
      onChange({ target: target } as React.ChangeEvent<HTMLInputElement>);
    };

    // The element emitting the event is the <trix-editor>
    editorRef.current.addEventListener('trix-change', handleChange);

    return () => {
      editorRef.current.removeEventListener('trix-change', handleChange);
    };
  }, [onChange]);

  useEffect(() => {
    if (inputRef.current) {
      // Setting the editor's value is done through the hidden input field.
      inputRef.current.value = value;
    }
  }, [value]);

  return (
    <>
      <input
        type="hidden"
        id={id}
        name={name}
        defaultValue={value}
        ref={inputRef}
      />
      <trix-editor input={id} required={required} class='form-control trix-content' ref={editorRef as any}></trix-editor>
    </>
  );
};

export default FormRichText;
